import { render, staticRenderFns } from "./traceability-item.vue?vue&type=template&id=cf49cc1c&"
import script from "./traceability-item.vue?vue&type=script&lang=js&"
export * from "./traceability-item.vue?vue&type=script&lang=js&"
import style0 from "./traceability-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports